import { createContext } from 'react';

import { LegendItem } from '../../../../core/components/legend/categorical/types/legend.js';

export type DisplayConfigProps = {
  hovered?: LegendItem | undefined;
  showLabels?: boolean;
};

export const DisplayConfigContext = createContext<DisplayConfigProps>({});

DisplayConfigContext['displayName'] = 'DisplayConfigContext';
